import React from 'react';
import Header from '@components/Header';
import GroupActivityFilterSetter from './GroupActivityHeaderFilter';
import { GroupTitle } from '@views/Group';
import styles from './GroupActivityHeader.module.scss';
import { useSelector } from 'react-redux';
import { selectNavBarState } from '@repo/redux/reducers/ui/navBar';
import cn from 'classnames';

export default function GroupActivityHeader() {
  const { status } = useSelector(selectNavBarState);

  return (
    <Header
      actions={<GroupActivityFilterSetter />}
      titleClassName={styles.title}
      className={cn(styles.header, styles[`navBar-${status}`])}
    >
      <GroupTitle />
    </Header>
  );
}
